import {IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { DamageTypeEnum, FgDamageLevelEnum } from '@gtpl/shared-models/warehouse-management';

export class FgDamagesDto{
    @ApiProperty()
    fgDamageId:number;

    @ApiProperty()
    LocationId:number;

   @ApiProperty()
   saleOrderId:number;

   @ApiProperty()
   saleOrderItemId:number;

   
   @ApiProperty()
   stockId:number;

   @ApiProperty()
   damageType:DamageTypeEnum;
   
   @ApiProperty()
    damageLevel:FgDamageLevelEnum

   @ApiProperty()
    noOfCartons:number

   @ApiProperty()
   damageBy:number

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;
    
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "created user should be only numbers" })
    createdUser: string;

    updatedAt: Date;

   @ApiProperty()
   @MaxLength(40, { message: "Updated User allows maximum 40 characters" })
   @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: "updated user should be only numbers" })
   updatedUser: string;
    
   @ApiProperty()
   unitId:number;
   versionFlag: number;

   @ApiProperty()
   damageReason:string
}